import { ExperimentInfo } from '@pulse/common';

export const DEFAULT_DEBUG_EXPERIMENT: ExperimentInfo = {
    id: '',
    variant: '',
    app: '',
    name: '',
    url: '',
};

export const DEFAULT_TRAFFIC_SOURCE = {
    referrer: { url: '', internal: false },
    landingPageURL: '',
    clickId: { source: '', value: '' },
    utmParams: {
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_content: '',
    },
};
